import React, { useState, useEffect } from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import { setLoading, setSnackInfo } from '../redux/actions/appAction'
import Tooltip from '@material-ui/core/Tooltip';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import HttpService from '../services/httpService';
import { DownloadOutlined } from '@ant-design/icons'
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import {DialogTitle} from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import { Select, MenuItem, Modal , Stepper, 
  Step, 
  StepLabel, 
  StepContent, 
  Chip, } from '@material-ui/core';
import moment from 'moment';


function LinearProgressWithLabel(props) {
  return (
    <Box display="block" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={50}>
        <Typography variant="body2" color="textSecondary">{`${props.value.toFixed(2)}%`}</Typography>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 850,
  }
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);



const PaymentRequestView = (props) => {
  const classes = useStyles();

  const [paymentList, setPaymentList] = useState([])
  const [openDialog,setOpenDialog] = useState(false)
  const [totalData,setTotalData ] = useState({
    attachment:[],
    remarks:""
  })
  const [fileUploaded,setFileUploaded] = useState(false)
  const [uploadedFileCount, setUploadedFileCount] = useState(0);
  const [selectedData,setSelectedData]  = useState({})
  const [selectedIndex,setSelectedIndex]  = useState({})
  const [clickedButton, setClickedButton] = useState("");
  const [dropdownValues, setDropdownValues] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [selectedSOType, setSelectedSOType] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [gstSubmitting, setGstSubmitting] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);

  const [gstDialogOpen, setGstDialogOpen] = useState(false)
  const [gstSelectedData, setGstSelectedData] = useState({})
  const [gstForm, setGstForm] = useState({ invoiceNumber: "", attachment: [], gstChallan: [], remarks: "" })
  const [gstHistoryOpen, setGstHistoryOpen] = useState(false)
  const [gstHistory, setGstHistory] = useState([])
  const [gstHistorySoNumber, setGstHistorySoNumber] = useState("")

  useEffect(() => {
    setData()
    setAmountType([])
    // eslint-disable-next-line
  }, [props])

  const setData = () => {
    console.log(props,"props")
    setPaymentList(props.PAYMENTLIST)
  }
  const [amountType, setAmountType] = useState([])
  const handleAmountRadioChange = (e, index) => {

    let parsedAmountType = JSON.parse(JSON.stringify(amountType))
    let type = parsedAmountType.find((item, idx) => idx === index)
    type = {}
    type.type = e.target.value
    type.value = ""
    parsedAmountType[index] = type
    setAmountType(parsedAmountType)
  }

  const handleAmountChange = (e, index) => {
    let parsedAmountType = JSON.parse(JSON.stringify(amountType))
    const type = parsedAmountType.find((item, idx) => idx === index)
    if (type.type === "AMOUNT" && +e.target.value <= +paymentList[index].remainingAmount) {
      type.value = e.target.value
      type.amount = e.target.value
      parsedAmountType[index] = type
      setAmountType(parsedAmountType)
    } else if (type.type === "PERCENTAGE" && (Number(((paymentList[index]?.remainingAmount / paymentList[index]?.total) * 100).toFixed(2)) >= e.target.value)) {
      let value = (paymentList[index]?.total * e.target.value) / 100
      type.amount = value
      type.value = e.target.value
      parsedAmountType[index] = type
      setAmountType(parsedAmountType)
    }
  }


//  sending the req.body for raising payments..
const raisePayementRequest = async () => {
  if(selectedSOType === ""){
   return  props.setSnackInfo("Please Select One SO Type", "error");
  }
  let obj = {
    amount: selectedData?.total,
    attachment: totalData?.attachment,
    remarks: totalData?.remarks,
    soType:selectedSOType
  }

    if (submitting) return
    setSubmitting(true)
    props.setLoading(true)
    try
    {
      if(props.RADIOVALUE === 'PO' || props.RADIOVALUE === 'SO')
      {
        let missing_docs = ''

        if(!paymentList[selectedIndex].vendorAadhar || (paymentList[selectedIndex].vendorAadhar.length < 1))
        {
          missing_docs += 'Aadhar Card,'
          
        }

        if(!paymentList[selectedIndex].vendorPAN || (paymentList[selectedIndex].vendorPAN.length < 1))
        {
          missing_docs += 'PAN Card,'
          
        }

        if(missing_docs.length > 0)
        {
          props.setLoading(false)
          setSubmitting(false)
          props.setSnackInfo(`${paymentList[selectedIndex].vendorName} did not provided ${missing_docs} can't raise PO/SO for them.`, 'error')
          return
        }
      }

      if (props.RADIOVALUE === "SO")
      {
        let response = await HttpService.raiseSOPaymentRequest(paymentList[selectedIndex].id, { amount: amountType[selectedIndex].amount, obj}, props?.SCOPE) 
        if (response.status === 200) {
          props.setSnackInfo("Payment Request Raised Successfully", "success")
          setAmountType([])
        }else if (response.status === 406) {
          props.setSnackInfo("Payment request already raised", "error")
          setAmountType([])
          
        }
      }
      else
      {
        let response = await HttpService.raisePOPaymentRequest(paymentList[selectedIndex].id, { amount: amountType[selectedIndex].amount }, props?.SCOPE)
        if (response.status === 200) {
          props.setSnackInfo("Payment Request Raised Successfully", "success")
          setAmountType([])
          
        } else if (response.status === 406) {
          setAmountType([])
          props.setSnackInfo("Payment request already raised", "error")
        }
      }
      props.setLoading(false)
    }
    catch (error)
    {
      console.error(error)
      props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }

  setOpenDialog(false)
  props.REFRESH()
  props.setLoading(false)
  setSubmitting(false)
}
  const openDialogBox = (data, index, buttonType)=>{
    setSelectedData(data)
    setSelectedIndex(index)
    setClickedButton(buttonType)
    try{
      props.setLoading(true)
      if (props.RADIOVALUE === 'PO' || props.RADIOVALUE === 'SO') {
        let missing_docs = ''

        if (!paymentList[index].vendorAadhar || (paymentList[index].vendorAadhar.length < 1)) {
          missing_docs += 'Aadhar Card,'

        }

        if (!paymentList[index].vendorPAN || (paymentList[index].vendorPAN.length < 1)) {
          missing_docs += 'PAN Card,'
        }
        if (missing_docs.length > 0) {
          props.setLoading(false)
          props.setSnackInfo(`${paymentList[index].vendorName} did not provided ${missing_docs} can't raise PO/SO for them.`, 'error')
          return
        } else {
          props.setLoading(false)
          setOpenDialog(true)
        }
      }
    }catch(err){
      props.setSnackInfo(`Error`, 'error')
    }  
  }

  const onImageChange = async (e) => {
    props.setLoading(true);
    
    try {
      const filesArray = Array.from(e.target.files);
      
      for (const file of filesArray) {
        const fd = new FormData();
        fd.append("file", file);
        fd.append("customerName", selectedData.orderId + "_" + selectedData.code);
        
        const fileUploadRes = await HttpService.uploadFile(fd);
        
        setTotalData((prevData) => ({
          ...prevData,
          attachment: [...prevData.attachment, fileUploadRes.data],
        }));
      }
      
      setFileUploaded(true);
      setUploadedFileCount((prevCount) => prevCount + filesArray.length);
    } catch (err) {
      props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
    } finally {
      props.setLoading(false);
    }
  };
  


  const raisePayementRequestForPO = async (index) =>
    {
      
      props.setLoading(true)
      try
      {
        if(props.RADIOVALUE === 'PO')
        {
          let missing_docs = ''
  
          if(!paymentList[index].vendorAadhar || (paymentList[index].vendorAadhar.length < 1))
          {
            missing_docs += 'Aadhar Card,'
            
          }
  
          if(!paymentList[index].vendorPAN || (paymentList[index].vendorPAN.length < 1))
          {
            missing_docs += 'PAN Card,'
            
          }
  
          if(missing_docs.length > 0)
          {
            props.setLoading(false)
            props.setSnackInfo(`${paymentList[index].vendorName} did not provided ${missing_docs} can't raise PO/SO for them.`, 'error')
            return
          }
        }
  
       
          const response = await HttpService.raisePOPaymentRequest(paymentList[index].id, { amount: amountType[index].amount }, props?.SCOPE)
          if (response.status === 200) {
            props.setSnackInfo("Payment Request Raised Successfully", "success")
            setAmountType([])
            
          } else if (response.status === 406) {
            setAmountType([])
            props.setSnackInfo("Payment request already raised", "error")
          }
        
        props.setLoading(false)
      }
      catch (error)
      {
        console.error(error)
        props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
      }
  
      props.REFRESH()
  
      props.setLoading(false)
  }

  const raisePayementCompleted = async()=>{
    try{
      let obj = {
        amount: selectedData.total,
        attachment: totalData.attachment,
        remarks: totalData.remarks
      }
      
      if (props.RADIOVALUE === "SO")
      {
        const response = await HttpService.soPaymentCompltedRequest(selectedData.id, obj, props?.SCOPE)
        if (response.status === 200) {
          props.setSnackInfo("Payment Request Raised Successfully", "success")
          setAmountType([])
        }else if (response.status === 406) {
          props.setSnackInfo("Payment request already raised", "error")
          setAmountType([])
          
        }
      }
      else
      {
        const response = await HttpService.raisePOPaymentCompleted(selectedData.id, obj, props?.SCOPE)
        if (response.status === 200) {
          props.setSnackInfo("Payment Request Raised Successfully", "success")
          setAmountType([])
          
        } else if (response.status === 406) {
          setAmountType([])
          props.setSnackInfo("Payment request already raised", "error")
        }
      }
      
    }catch (err){
      console.error(err)
      props.setSnackInfo(err?.response?.data ?? "Something Went Wrong", "error")
    }
    
    setOpenDialog(false)
    props.REFRESH()
    props.setLoading(false)

  }
  //  new things are from here 
const [open, setOpen] = useState(false);
const handleOpen = () => setOpen(true);
const handleClose = () => setOpen(false);

const GetApprovalRejectLogs = async (orderId) => {
  if (!orderId) {
    props.setSnackInfo('Order ID not found', 'warning');
    return;
  }
  handleOpen(); // open the modal or drawer
  await showPaymentHistory(orderId);
};

// 3. Data fetcher
const showPaymentHistory = async (id) => {
  props.setLoading(true);
  try {
    const result = await HttpService.allPaymentHistoryOfASO(id);
    if (result.status === 200) {
      setPaymentHistory(result?.data?.data?.paymentRequests); 
    }
  } catch (err) {
    console.error(err);
    props.setSnackInfo('Error fetching data', "error");
  } finally {
    props.setLoading(false);
  }
};

const SO_TYPES = [
 'Transport',
  'Unloading',
  'Cushion',
  'Wallpaper Fixing',
  'Deep cleaning',
  'Debris',
  'Granite Fixing',
  'False ceiling',
  'Electrical',
  'Painting',
  'Carpentry',
];

// ------------------- Vendor GST payment for an SO -------------------

// GST is charged on the SO material total; fall back to a local calc if the
// API has not sent the pre-computed amount (older payload).
const getGstAmount = (data) => {
  if (data?.gstAmount) return Number(data.gstAmount)
  const details = Array.isArray(data?.gstDetails) ? data.gstDetails : (data?.gstDetails ? [data.gstDetails] : [])
  const rate = details.reduce((sum, detail) => sum + (Number(detail?.rate) || 0), 0)
  return Number((((Number(data?.total) || 0) * rate) / 100).toFixed(2))
}

const getGstRate = (data) => {
  if (data?.gstRate) return Number(data.gstRate)
  const details = Array.isArray(data?.gstDetails) ? data.gstDetails : (data?.gstDetails ? [data.gstDetails] : [])
  return details.reduce((sum, detail) => sum + (Number(detail?.rate) || 0), 0)
}

const getGstDisabledReason = (data) => {
  if (data?.paymentBlocked) return "Payment is blocked for this SO"
  if (data?.gstPaymentRaised) return "GST payment has already been raised for this SO"
  if (!getGstAmount(data)) return "GST amount for this SO is zero"
  return ""
}

const resetGstForm = () => {
  setGstForm({ invoiceNumber: "", attachment: [], gstChallan: [], remarks: "" })
}

const openGstDialog = (data) => {
  const reason = getGstDisabledReason(data)
  if (reason) {
    props.setSnackInfo(reason, "error")
    return
  }
  resetGstForm()
  setGstSelectedData(data)
  setGstDialogOpen(true)
}

const closeGstDialog = () => {
  setGstDialogOpen(false)
  resetGstForm()
  setGstSelectedData({})
}

// Shared by both mandatory documents - 'attachment' is the invoice, 'gstChallan' the challan.
const onGstFileUpload = async (e, field) => {
  props.setLoading(true)
  try {
    const filesArray = Array.from(e.target.files)
    for (const file of filesArray) {
      const fd = new FormData()
      fd.append("file", file)
      fd.append("customerName", `${gstSelectedData?.orderId}_${field === "gstChallan" ? "GST_CHALLAN" : "GST"}`)
      const fileUploadRes = await HttpService.uploadFile(fd)
      setGstForm((prev) => ({ ...prev, [field]: [...prev[field], fileUploadRes.data] }))
    }
  } catch (err) {
    props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
  } finally {
    props.setLoading(false)
    // allow re-selecting the same file after a clear
    e.target.value = null
  }
}

// clears just one document, so redoing the challan does not wipe the invoice
const clearGstFile = (field) => setGstForm((prev) => ({ ...prev, [field]: [] }))

const raiseGstPaymentRequest = async () => {
  if (!gstForm.invoiceNumber.trim()) return props.setSnackInfo("Invoice No/ID is mandatory", "error")
  if (!gstForm.attachment.length) return props.setSnackInfo("Invoice image is mandatory", "error")
  if (!gstForm.gstChallan.length) return props.setSnackInfo("GST Challan is mandatory", "error")

  if (gstSubmitting) return
  setGstSubmitting(true)
  props.setLoading(true)
  try {
    const response = await HttpService.raiseSoGstPaymentRequest(gstSelectedData.id, {
      invoiceNumber: gstForm.invoiceNumber.trim(),
      attachment: gstForm.attachment,
      gstChallan: gstForm.gstChallan,
      remarks: gstForm.remarks
    }, props?.SCOPE)
    if (response.status === 200) {
      props.setSnackInfo("GST Payment Request Raised Successfully", "success")
      closeGstDialog()
      props.REFRESH()
    }
  } catch (error) {
    console.error(error)
    if (error?.response?.status === 406) {
      props.setSnackInfo("GST payment has already been raised for this SO", "error")
    } else {
      props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }
  }
  props.setLoading(false)
  setGstSubmitting(false)
}

// GST payment history of a single SO - the GST counterpart of GetApprovalRejectLogs.
const GetGstPaymentLogs = async (orderId) => {
  if (!orderId) {
    props.setSnackInfo('Order ID not found', 'warning')
    return
  }
  setGstHistorySoNumber(orderId)
  setGstHistoryOpen(true)
  props.setLoading(true)
  try {
    const result = await HttpService.getSoGstPaymentHistoryBySo(orderId)
    if (result.status === 200) setGstHistory(result.data || [])
  } catch (err) {
    console.error(err)
    setGstHistory([])
    props.setSnackInfo(err?.response?.data ?? "Error fetching GST payment history", "error")
  }
  props.setLoading(false)
}

const closeGstHistory = () => {
  setGstHistoryOpen(false)
  setGstHistory([])
  setGstHistorySoNumber("")
}


const handleDropdownChange = (event, index) => {
  setDropdownValues((prev) => ({
    ...prev,
    [index]: event.target.value,
  }));
};
const handleClear = () => {
  setTotalData({
    attachment: [],
    remarks: "",
  });
  setFileUploaded(false);
  setUploadedFileCount(0);
};




  return (
    <div>
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small" aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Sl No</StyledTableCell>
              <StyledTableCell>Order Id</StyledTableCell>
              <StyledTableCell>Client & Code</StyledTableCell>
              { props.RADIOVALUE === "SO" &&   <StyledTableCell>SO Type</StyledTableCell> }
              { props.RADIOVALUE === "SO" &&   <StyledTableCell>Approval/Reject Logs</StyledTableCell> }
              { props.RADIOVALUE === "SO" &&   <StyledTableCell>GST Logs</StyledTableCell> }
              { props.RADIOVALUE === "SO" &&   <StyledTableCell>Days From Material Dispatch</StyledTableCell> }
              <StyledTableCell>Vendor</StyledTableCell>
              <StyledTableCell>Created At</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Total</StyledTableCell>
              {props.RADIOVALUE === "SO" && <StyledTableCell>Already Raised</StyledTableCell>}
              {props.RADIOVALUE === "SO" && <StyledTableCell>Already Approved</StyledTableCell> }
              <StyledTableCell>Type</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentList.map((data, i) => <StyledTableRow key={i + 1}>
              <StyledTableCell>{i + 1}</StyledTableCell>
              <StyledTableCell>{data?.orderId}</StyledTableCell>
              <StyledTableCell>{data?.code}</StyledTableCell>
               {/* SO Type Dropdown */}
              { props.RADIOVALUE === "SO" &&   
            <StyledTableCell>
                  <Select
                    size="small"
                    displayEmpty
                    value={selectedRowIndex === i ? selectedSOType : ''}
                    onChange={(e) => {
                      setSelectedRowIndex(i);
                      setSelectedSOType(e.target.value);
                    }}
                    sx={{ width: 200, backgroundColor: '#fff' }}
                  >
                    <MenuItem value="" disabled>Select SO Type</MenuItem>
                    {SO_TYPES.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>

          </StyledTableCell> }
              {
                props.RADIOVALUE === 'SO' && (
                  <StyledTableCell>
          <Button
            variant="contained"
            color="primary"
            size="small"
            // onClick={GetApprovalRejectLogs}
            onClick={() => GetApprovalRejectLogs(data?.orderId)} 
            sx={{
              textTransform: 'none',
              borderRadius: '8px',
              backgroundColor: '#1976d2',
              ':hover': {
                backgroundColor: '#1565c0',
              },
            }}
          >
            View
          </Button>
        </StyledTableCell>
                )
              }
              {
                props.RADIOVALUE === 'SO' && (
                  <StyledTableCell>
                    <Tooltip title={data?.gstRequired ? "View GST payment history of this SO" : "GST was not opted for this SO"}>
                      <span>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => GetGstPaymentLogs(data?.orderId)}
                          disabled={!data?.gstRequired}
                          style={data?.gstRequired ? { background: '#2E7D32', borderRadius: '8px' } : { borderRadius: '8px' }}
                        >
                          GST
                        </Button>
                      </span>
                    </Tooltip>
                  </StyledTableCell>
                )
              }
              {
                props.RADIOVALUE === 'SO' && (
                  <StyledTableCell>
                    {data?.leadDetails?.materialDispatchedDate
                      ? moment().diff(moment(data.leadDetails.materialDispatchedDate), 'days')
                      : "-"}
                  </StyledTableCell>
                )
              }
              <StyledTableCell>{data?.vendorName}</StyledTableCell>
              <StyledTableCell>{data?.createdAt}</StyledTableCell>
              <StyledTableCell>{data?.status}</StyledTableCell>
              {/* <StyledTableCell>₹{data?.total}</StyledTableCell> */}
              <StyledTableCell>
                ₹{data?.total}
                {props.RADIOVALUE === "SO" && data?.gstRequired && (
                  <>
                    <Typography variant="caption" display="block" color="textSecondary">
                      GST ({getGstRate(data)}%): ₹{getGstAmount(data)}
                    </Typography>
                    <Typography variant="caption" display="block" color="textPrimary">
                      Incl. GST: ₹{(Number(data?.total || 0) + getGstAmount(data)).toFixed(2)}
                    </Typography>
                  </>
                )}
              </StyledTableCell>
              { props.RADIOVALUE === 'SO' && (
              <StyledTableCell>₹{data?.alreadyRaisedAmount}</StyledTableCell>
              )}
              {props.RADIOVALUE === 'SO' && (
                <StyledTableCell>
                  <Box>
                    <Typography variant="body2" color="textPrimary">
                      ₹{(data?.total - data?.remainingAmount).toFixed(2)}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={(((data?.total - data?.remainingAmount) / data?.total) * 100)}
                      style={{ height: 8, borderRadius: 4 }}
                    />
                    <Typography variant="caption" color="textSecondary">
                      {(((data?.total - data?.remainingAmount) / data?.total) * 100).toFixed(2)}%
                    </Typography>
                  </Box>
                </StyledTableCell>
              )}
              <StyledTableCell>
                <FormControl component="fieldset">
                  <RadioGroup aria-label="type" name="type" value={amountType[i]?.type} onChange={(e) => handleAmountRadioChange(e, i)}>
                    <div className='modal-header-radio'>
                      <FormControlLabel value="AMOUNT" control={<Radio />} label="Amount" />
                      <FormControlLabel value="PERCENTAGE" control={<Radio />} label="Percentage" />
                    </div>
                  </RadioGroup>
                  {amountType[i]?.type && <Tooltip title={`Remaining value ${amountType[i]?.type === "PERCENTAGE" ? `${((data?.remainingAmount / data?.total) * 100).toFixed(2)}%` : `${data?.remainingAmount}₹`} `}>
                    <TextField InputLabelProps={{ shrink: true }} type="number" onChange={(e) => handleAmountChange(e, i)} value={amountType[i]?.value} label={amountType[i]?.type} variant="outlined" />
                  </Tooltip>}
                  {amountType[i]?.type === "PERCENTAGE" && <TextField style={{ marginTop: 10 }} InputLabelProps={{ shrink: true }} type="number" disabled={true} label="AMOUNT" value={amountType[i]?.amount} variant="outlined" />}
                </FormControl>
              </StyledTableCell>
                <StyledTableRow >
                  <StyledTableCell style={{ cursor: "pointer" }} >
                  <Button variant="contained" color="primary" style={{ background: "#F50057", margin: 5 }} 
                  onClick={() =>
                    props.RADIOVALUE === "PO"
                      ? raisePayementRequestForPO(i)
                      : openDialogBox(data, i, "Raise Payment")
                  } disabled={
                    data?.paymentBlocked ||
                    (
                      props.RADIOVALUE === "SO" 
                        ? (data?.total - data?.remainingAmount) >= data?.total
                        : data?.paymentCompleted === true
                    )
                  }>Raise Payment</Button>
                     {props.RADIOVALUE === "SO" && data?.gstRequired && (
                    <Tooltip title={getGstDisabledReason(data) || `Raise vendor's GST payment of ₹${getGstAmount(data)} (${getGstRate(data)}%)`}>
                      <span>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ background: getGstDisabledReason(data) ? undefined : "#2E7D32", margin: 5 }}
                          onClick={() => openGstDialog(data)}
                          disabled={!!getGstDisabledReason(data)}
                        >
                          {data?.gstPaymentRaised ? "GST Payment Raised" : "Raise GST Payment"}
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                  </StyledTableCell>
                </StyledTableRow>
              <StyledTableRow >
                <StyledTableCell style={{ cursor: "pointer" }} >
                {
                  props.RADIOVALUE === "PO" && 
                  (<Button variant="contained" color="primary" style={{ background: "#F50057", margin: 5 }} onClick={() => openDialogBox(data, i, "Payment Completed")} disabled={data?.paymentCompleted}>Payment Completed</Button>)
                }
                </StyledTableCell>
              </StyledTableRow>
              <Tooltip title={`Download ${props.RADIOVALUE}`} >
                <StyledTableRow style={{ cursor: "pointer" }}>
                  <StyledTableCell onClick={() => window.open(data.link)}><DownloadOutlined /></StyledTableCell>
                </StyledTableRow>
              </Tooltip>
              <StyledTableRow>
                {
                  data?.paymentBlocked ? (
                    <StyledTableCell>Payment Blocked</StyledTableCell>
                  ) : (
                    (props.RADIOVALUE === "SO"
                      ? (data?.total - data?.remainingAmount) < data?.total
                      : data.paymentCompleted !== true
                    ) ? (
                      <StyledTableCell>
                        <LinearProgressWithLabel
                          value={((data?.total - data?.remainingAmount) / data?.total) * 100 || 0}
                        />
                      </StyledTableCell>
                    ) : (
                      <StyledTableCell>Payment Completed</StyledTableCell>
                    )
                  )
                }
          </StyledTableRow>
            </StyledTableRow>)}
          </TableBody>
        </Table>
      </TableContainer>
      {/* this is rasied payment dialog box */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} aria-labelledby="form-dialog-title" maxWidth='lg'>
        <DialogTitle id="form-dialog-title">Verify Details</DialogTitle>
        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
           <>
              <input
                accept="*"
                className={classes.input}
                id="contained-button-file"
                multiple
                type="file"
                onChange={onImageChange}
                style={{ display: 'none' }}
              />
            <label htmlFor="contained-button-file">
              <Button
                variant="contained"
                color="primary"
                component="span"
                startIcon={<CloudUploadIcon />}
              >
                Upload Site Photos
              </Button>

              {fileUploaded && (
                <>
                  <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: 'green', fontSize: 30 }} />
                  <span style={{ marginLeft: 8, fontWeight: 'bold' }}>
                    ({uploadedFileCount})
                  </span>
                </>
              )}
            </label>
             <Button
                color="secondary" variant='outlined'
                component="span"
              style={{ marginLeft: 30 }}
              onClick={handleClear}
              >
                Clear
              </Button>
              <TextField
              autoFocus
              margin="dense"
              label="Remarks"
              fullWidth
              onChange={(e) => setTotalData({
                ...totalData,
                remarks: e.target.value
              })}
              />
      
            </>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)} color="secondary" variant='outlined'>
              Cancel
            </Button>
            <Button 
              onClick={() => {
                if (clickedButton === "Payment Completed") {
                  raisePayementCompleted();
                } else if (clickedButton === "Raise Payment") {
                  raisePayementRequest();
                }
              }} 
              color="primary" 
              variant='contained'
              disabled={!fileUploaded || submitting}
            >
              {submitting ? 'Submitting...' : 'Submit'}
            </Button>
          </DialogActions>
        </FormControl>
      </Dialog>
      {/* Raise vendor's GST payment for an SO — once per SO, by the SO raiser only */}
      <Dialog open={gstDialogOpen} onClose={closeGstDialog} aria-labelledby="gst-dialog-title" maxWidth="sm" fullWidth>
        <DialogTitle id="gst-dialog-title">Raise GST Payment — {gstSelectedData?.orderId}</DialogTitle>
        <FormControl style={{ marginLeft: 16, marginRight: 16, marginBottom: 10, display: 'block' }}>
          <Box style={{ background: '#f5f5f5', borderRadius: 4, padding: 10, marginBottom: 12 }}>
            <Typography variant="body2"><strong>Vendor:</strong> {gstSelectedData?.vendorName || '-'}</Typography>
            <Typography variant="body2"><strong>SO Amount:</strong> ₹{gstSelectedData?.total}</Typography>
            <Typography variant="body2"><strong>GST Rate:</strong> {getGstRate(gstSelectedData)}%</Typography>
            <Typography variant="body2"><strong>GST Payable:</strong> ₹{getGstAmount(gstSelectedData)}</Typography>
            <Typography variant="caption" color="textSecondary">
              GST payment can be raised only once for this SO.
            </Typography>
          </Box>

          <TextField
            required
            margin="dense"
            label="Invoice No / ID"
            fullWidth
            variant="outlined"
            value={gstForm.invoiceNumber}
            onChange={(e) => setGstForm({ ...gstForm, invoiceNumber: e.target.value })}
          />

          {[
            { field: 'attachment', inputId: 'gst-invoice-file', label: 'Upload Invoice *' },
            { field: 'gstChallan', inputId: 'gst-challan-file', label: 'Upload GST Challan *' }
          ].map(({ field, inputId, label }) => (
            <div key={field} style={{ marginTop: 14 }}>
              <input
                accept="image/*,application/pdf"
                id={inputId}
                multiple
                type="file"
                onChange={(e) => onGstFileUpload(e, field)}
                style={{ display: 'none' }}
              />
              <label htmlFor={inputId}>
                <Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />}>
                  {label}
                </Button>
                {gstForm[field].length > 0 && (
                  <>
                    <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: 'green', fontSize: 30 }} />
                    <span style={{ marginLeft: 8, fontWeight: 'bold' }}>({gstForm[field].length})</span>
                  </>
                )}
              </label>
              <Button
                color="secondary"
                variant="outlined"
                component="span"
                style={{ marginLeft: 20 }}
                onClick={() => clearGstFile(field)}
              >
                Clear
              </Button>
            </div>
          ))}

          <TextField
            margin="dense"
            label="Remarks"
            fullWidth
            value={gstForm.remarks}
            onChange={(e) => setGstForm({ ...gstForm, remarks: e.target.value })}
          />

          <DialogActions>
            <Button onClick={closeGstDialog} color="secondary" variant="outlined">Cancel</Button>
            <Button
              onClick={raiseGstPaymentRequest}
              color="primary"
              variant="contained"
              disabled={!gstForm.invoiceNumber.trim() || !gstForm.attachment.length || !gstForm.gstChallan.length || gstSubmitting}
            >
              {gstSubmitting ? 'Submitting...' : 'Submit'}
            </Button>
          </DialogActions>
        </FormControl>
      </Dialog>

      {/* GST payment history of the selected service order */}
      <Modal open={gstHistoryOpen} onClose={closeGstHistory}>
        <Box style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '95%',
          maxWidth: 1100,
          maxHeight: '90vh',
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: 6,
          padding: 24,
          overflow: 'auto'
        }}>
          <Typography variant="h6" component="h2">GST Payment History {gstHistorySoNumber ? `- ${gstHistorySoNumber}` : ''}</Typography>
          {gstHistory.length === 0 ? (
            <Typography style={{ marginTop: 16 }}>No GST payment raised for this SO yet.</Typography>
          ) : (
            <TableContainer component={Paper} style={{ marginTop: 16 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Sl No</StyledTableCell>
                    <StyledTableCell>SO Id</StyledTableCell>
                    <StyledTableCell>Client & Code</StyledTableCell>
                    <StyledTableCell>Vendor</StyledTableCell>
                    <StyledTableCell>Invoice No/ID</StyledTableCell>
                    <StyledTableCell>GST Rate</StyledTableCell>
                    <StyledTableCell>GST Amount</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Raised By</StyledTableCell>
                    <StyledTableCell>Raised At</StyledTableCell>
                    <StyledTableCell>Approved/Rejected By</StyledTableCell>
                    <StyledTableCell>Approved/Rejected At</StyledTableCell>
                    <StyledTableCell>Invoice</StyledTableCell>
                    <StyledTableCell>GST Challan</StyledTableCell>
                    <StyledTableCell>Remarks</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {gstHistory.map((item, index) => (
                    <StyledTableRow key={item._id || index}>
                      <StyledTableCell>{index + 1}</StyledTableCell>
                      <StyledTableCell>{item?.orderId}</StyledTableCell>
                      <StyledTableCell>{item?.clientName}_{item?.projectCode}</StyledTableCell>
                      <StyledTableCell>{item?.vendorName || '-'}</StyledTableCell>
                      <StyledTableCell>{item?.invoiceNumber}</StyledTableCell>
                      <StyledTableCell>{item?.gstRate}%</StyledTableCell>
                      <StyledTableCell>₹{item?.amount}</StyledTableCell>
                      <StyledTableCell>{item?.status}</StyledTableCell>
                      <StyledTableCell>{item?.raisedBy?.name || '-'}</StyledTableCell>
                      <StyledTableCell>
                        {item?.raisedAt || item?.createdAt
                          ? moment(item.raisedAt || item.createdAt).format("DD/MM/YYYY hh:mm A")
                          : "--"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {item?.status === 'Approved'
                          ? (item?.approvedBy?.name || '-')
                          : item?.status === 'Rejected'
                            ? (item?.rejectedBy?.name || '-')
                            : '-'}
                      </StyledTableCell>
                      <StyledTableCell>
                        {item?.status === 'Approved' && item?.approvedAt
                          ? moment(item.approvedAt).format("DD/MM/YYYY hh:mm A")
                          : item?.status === 'Rejected' && item?.rejectedAt
                            ? moment(item.rejectedAt).format("DD/MM/YYYY hh:mm A")
                            : "--"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {(item?.attachment || []).map((file, fileIndex) => (
                          <span
                            key={fileIndex}
                            style={{ cursor: 'pointer', marginRight: 8 }}
                            onClick={() => window.open(file)}
                          >
                            <DownloadOutlined />
                          </span>
                        ))}
                      </StyledTableCell>
                      <StyledTableCell>
                        {(item?.gstChallan || []).length
                          ? (item.gstChallan).map((file, fileIndex) => (
                            <span
                              key={fileIndex}
                              style={{ cursor: 'pointer', marginRight: 8 }}
                              onClick={() => window.open(file)}
                            >
                              <DownloadOutlined />
                            </span>
                          ))
                          : '-'}
                      </StyledTableCell>
                      <StyledTableCell>
                        {item?.remarks || '-'}
                        {item?.status === 'Rejected' && item?.rejectReason && (
                          <Typography variant="caption" display="block" color="error">
                            Reason: {item.rejectReason}
                          </Typography>
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <DialogActions>
            <Button onClick={closeGstHistory} color="secondary" variant="outlined">Close</Button>
          </DialogActions>
        </Box>
      </Modal>

       {/* Modal Code */}
       <Modal open={open} onClose={handleClose}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '95%',
          maxWidth: 1200,
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          overflow: 'auto'
        }}>
          <Typography variant="h6" component="h2">
            Approval / Reject Logs
          </Typography>

          <Typography sx={{ mt: 2 }}>
            Below are the approval or rejection logs for this payment:
          </Typography>

          {paymentHistory?.map((item, index) => {
                // Function to generate approval track steps
                // generateApprovalTrack function
                 const generateApprovalTrack = (payment) => {
                  const steps = [];
                  
                      // Helper function to determine who is the final approver
                    const getFinalApproverLabel = () => {
                      // If both secondApprover and finalApprover exist, Operation Head is final
                      if (payment?.secondApprover && payment?.finalApprover) {
                        return 'Operation Head';
                      }

                      // If only finalApprover exists , Senior Operation Manager is final
                      if (payment?.finalApprover && !payment?.secondApprover) {
                        return 'Senior Operation Manager';
                      }

                      return 'Operation Head'; 
                    };

                  // Define approval stages based on payment type
                  let approvalStages = payment?.paymentType === 'Capex'
                    ? [
                      { key: 'firstApprover', label: 'Growth Manager', dateKey: 'firstApprovalDate' },
                      { key: 'finalApprover', label: 'Operation Head', dateKey: 'finalApprovalDate' },
                    ]
                    : [
                      { key: 'firstApprover', label: 'Execution User', dateKey: 'firstApprovalDate' },
                      { key: 'secondApprover', label: 'Senior Operation Manager', dateKey: 'secondApprovalDate' },
                      { key: 'finalApprover', label: getFinalApproverLabel(), dateKey: 'finalApprovalDate' },
                    ];

                  //  If Senior Operation Manager approved directly to "Final" 
                  //  Senior Operation Manager is only evaluated once as the Final Approver.
                  if (payment?.paymentType !== 'Capex' && !payment.secondApprover && payment.finalApprover) {
                    approvalStages = [
                      { key: 'firstApprover', label: 'Execution User', dateKey: 'firstApprovalDate' },
                      { key: 'finalApprover', label: 'Senior Operation Manager', dateKey: 'finalApprovalDate' }
                    ];
                  }

                  // 3. Determine the "Raised By" role based on payment type and raisedBy presence
                  const getRaisedByRole = () => {
                    if (payment?.raisedBy?.name) {
                      return payment?.raisedBy.name;
                    }
                    return payment?.paymentType === 'Capex' ? 'Project Manager' : 'Vendor Manager';
                  };

                  if (payment?.status === 'Raised') {
                    // Always show "Raised By" step
                    steps.push({
                      label: 'Raised By',
                      role: getRaisedByRole(),
                      status: 'approved',
                      date: payment?.raisedAt || payment?.createdAt,
                    });

                    // If there's a currentApprover, show steps till current approver
                    if (payment.currentApprover) {
                      let currentApproverFound = false;

                      for (const stage of approvalStages) {
                        if (payment[stage.key] === null) continue;
                       // If this is the current approver stage
                        if (stage.label === payment.currentApprover) {
                          steps.push({
                            label: stage.label,
                            role: payment[stage.key]?.name || stage.label,
                            status: 'pending',
                            date: payment[stage.dateKey] || null,
                          });
                          currentApproverFound = true;
                          break;
                        } else {
                          // Previous stages should be approved
                          steps.push({
                            label: stage.label,
                            role: payment[stage.key]?.name || stage.label,
                            status: 'approved',
                            date: payment[stage.dateKey] || payment?.createdAt,
                          });
                        }
                      }

                      if (!currentApproverFound) {
                        steps.push({
                          label: payment.currentApprover,
                          role: payment.currentApprover,
                          status: 'pending',
                          date: null,
                        });
                      }
                    } else {
                      const firstStage = approvalStages[0];
                      steps.push({
                        label: firstStage.label,
                        role: payment[firstStage.key]?.name || firstStage.label,
                        status: 'pending',
                        date: payment[firstStage.dateKey] || null,
                      });
                    }
                  }
                  else if (payment?.status === 'Rejected') {
                    // Always start with "Raised By" as approved
                    steps.push({
                      label: 'Raised By',
                      role: getRaisedByRole(),
                      status: 'approved',
                      date: payment?.raisedAt || payment?.createdAt,
                    });
                    // Check if rejectedBy is present
                    if (payment?.rejectedBy) {
                      // Find the current approver stage and mark previous stages as approved
                      let rejectorFound = false;

                      for (let i = 0; i < approvalStages.length; i++) {
                        const stage = approvalStages[i];
                        // Skip if this stage is null (jumped stage)
                        if (payment[stage.key] === null) continue;

                        if (payment.currentApprover && stage.label.includes(payment.currentApprover)) {
                          steps.push({
                            label: stage.label,
                            role: payment.rejectedBy?.name || stage.label,
                            status: 'rejected',
                            date: payment.rejectedAt,
                          });
                          rejectorFound = true;
                          break;
                        } else {
                          // Previous stages are approved
                          steps.push({
                            label: stage.label,
                            role: payment[stage.key]?.name || stage.label,
                            status: 'approved',
                            date: payment[stage.dateKey] || payment?.createdAt,
                          });
                        }
                      }

                      if (!rejectorFound) {
                        steps.push({
                          label: 'Rejected By',
                          role: payment?.rejectedBy?.name || payment.currentApprover?.name || 'User',
                          status: 'rejected',
                          date: payment.rejectedAt,
                        });
                      }
                    } else {
                      for (let i = 0; i < Math.min(2, approvalStages.length); i++) {
                        const stage = approvalStages[i];
                        if (payment[stage.key] !== null) {
                          steps.push({
                            label: stage.label,
                            role: payment[stage.key]?.name || stage.label,
                            status: 'approved',
                            date: payment[stage.dateKey] || payment?.createdAt,
                          });
                        }
                      }

                      // Add rejection at next available stage
                      const rejectionStageIndex = Math.min(2, approvalStages.length - 1);
                      const rejectionStage = approvalStages[rejectionStageIndex];
                      steps.push({
                        label: rejectionStage.label,
                  // role: rejectionStage.label,
                        role: payment?.rejectedBy?.name || rejectionStage.label,
                        status: 'rejected',
                        date: payment.rejectedAt,
                      });
                    }
                  }
                  else if (payment?.status === 'Approved') {
                    // Start with "Raised By" as approved
                    steps.push({
                      label: 'Raised By',
                      role: getRaisedByRole(),
                      status: 'approved',
                      date: payment?.raisedAt || payment?.createdAt,
                    });

                    // Add all approval stages based on data
                    for (const stage of approvalStages) {
                      if (payment[stage.key] === null) continue;

                      if (payment.finalApprover || payment[stage.key]) {
                        steps.push({
                          label: stage.label,
                          role: payment[stage.key]?.name || stage.label,
                          status: 'approved',
                          date: payment[stage.dateKey] || payment.approvedAt || payment?.createdAt,
                        });
                      } else {
                        // Show as default approved if finalApprover exists
                        steps.push({
                          label: stage.label,
                          role: stage.label,
                          status: 'approved',
                          date: payment?.createdAt,
                        });
                      }
                    }
                  }

                  return steps;
                };
                const approvalSteps = generateApprovalTrack(item);

                return (
                  <Box
                    key={item._id}
                    sx={{
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      p: 2,
                      mt: 2,
                      backgroundColor: item.status === 'Approved' ? '#e8f5e9' : item.status === 'Rejected' ? '#ffebee' : '#fffde7',
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight="bold">
                      <strong>
                        {item.status === 'Approved'
                          ? 'Approved'
                          : item.status === 'Rejected'
                            ? 'Rejected'
                            : 'Raised'}
                      </strong>
                    </Typography>

                    <Typography><strong>Amount:</strong> ₹{item.amount}</Typography>
                    <Typography><strong>Project Type:</strong> {item.paymentType || ''}</Typography>
                    
                    {item.status === 'Approved' && (
                      <Typography><strong>Approved At:</strong> {item?.approvedAt || item?.finalApprovalDate
                        ? moment(item.approvedAt || item.finalApprovalDate).format("DD/MM/YYYY hh:mm A")
                        : "--"}
                      </Typography>
                    )}
                    {item.status === 'Rejected' && (
                      <>
                        <Typography><strong>Rejected At:</strong> {item?.rejectedAt
                          ? moment(item.rejectedAt).format("DD/MM/YYYY hh:mm A")
                          : "--"}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          <strong>Rejection Reason:</strong> {item.rejectReason || 'N/A'}
                        </Typography>
                      </>
                    )}
                    {item.status === 'Raised' && (
                      <Typography><strong>Raised At:</strong> {item?.createdAt ? moment(item.createdAt).format("DD/MM/YYYY hh:mm A") : "--"}</Typography>
                    )}

                    {/* Approval Track Stepper - Horizontal */}
                    <Box sx={{ mt: 3 }}>
                      <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2 }}>
                        Approval Track:
                      </Typography>

                      <Stepper orientation="horizontal" sx={{ mt: 1, flexWrap: 'wrap' }}>
                        {approvalSteps.map((step, stepIndex) => (
                          <Step key={stepIndex} active={true} completed={step.status === 'approved'}>
                            <StepLabel
                              StepIconComponent={() => (
                                <Box
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor:
                                      step?.status === 'approved' ? '#4caf50' :
                                        step?.status === 'rejected' ? '#f44336' : '#ff9800',
                                    color: 'white',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                  }}
                                >
                                  {step.status === 'approved' ? '✓' :
                                    step?.status === 'rejected' ? '✕' : '⧖'}
                                </Box>
                              )}
                              sx={{
                                '& .MuiStepLabel-label': {
                                  color: step?.status === 'rejected' ? 'error.main' :
                                    step?.status === 'approved' ? 'success.main' : 'warning.main',
                                  fontWeight: 'medium',
                                  fontSize: '0.875rem'
                                },
                                flexDirection: 'column',
                                alignItems: 'center'
                              }}
                            >
                              <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 0.5,
                                mt: 1,
                                minWidth: '120px',
                                textAlign: 'center'
                              }}>
                                <Typography variant="body2" fontWeight="medium" sx={{ lineHeight: 1.2 }}>
                                  {step?.label}
                                </Typography>
                                <Chip
                                  label={step.role}
                                  size="small"
                                  variant="outlined"
                                  sx={{
                                    fontSize: '0.7rem',
                                    height: '22px',
                                    backgroundColor:
                                      step?.status === 'approved' ? '#e8f5e9' :
                                        step?.status === 'rejected' ? '#ffebee' : '#fff3e0',
                                    color: step?.status === 'rejected' ? 'error.main' :
                                      step?.status === 'approved' ? 'success.main' : 'warning.main'
                                  }}
                                />
                                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                                  {step.date ? new Date(step.date).toLocaleDateString() : 'N/A'}
                                </Typography>
                                {step.status === 'rejected' && (
                                  <Typography variant="caption" color="error.main" sx={{ fontSize: '0.7rem', textAlign: 'center' }}>
                                    Rejected
                                  </Typography>
                                )}
                              </Box>
                            </StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </Box>

                    {item?.remarks && (
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        <strong>Remarks:</strong> {item?.remarks}
                      </Typography>
                    )}
                  </Box>
                );
              })}
        </Box>
      </Modal>
    </div >
  )
}

export default connect(null, { setLoading, setSnackInfo })(PaymentRequestView)
